module.exports = __webpack_public_path__ + "static/media/12-video.8c29645a.png";